import defaultNavItems from "./default-nav-items";
import clientNavItems from "./client-nav-items";


export default function () {
  /*var layout = localStorage.getItem('userLayout')
  if (layout === 'ClientLayout'){
    return clientNavItems()
  } else {
    return defaultNavItems()
  }
}*/
 return [
  {
    title: 'Clientes',
    roles:[],
    items: [{
      title: 'Clientes',
      htmlBefore: '<i class="material-icons">account_balance</i>',
      open: false,
      items:[{            
        title: 'Clientes',
        to: '/clients',
        htmlBefore: '<i class="material-icons">account_balance</i>',
        htmlAfter: ''
      },{
        title:'Grupo cliente',
        to:'/client_groups'
      },{
        title: 'Contratos',
        to: '/contracts',
        htmlBefore: '<i class="material-icons">work</i>',
        htmlAfter: ''
      },{
        title: 'Subcontactos',
        to: '/subcontacts/0',
        htmlBefore: '<i class="material-icons">ballot</i>',
        htmlAfter: ''
      }]
    }]
},
{
    title: 'Proveedores',
    roles:[],
    items: [{
      title: 'Proveedores',
      htmlBefore: '<i class="material-icons">build</i>',
      open: false,
      items:[{
        title:'Proveedores',
        to:'/providers',
      },{
        title: 'Subcontactos',
        to: '/subcontacts/-1',
        htmlBefore: '<i class="material-icons">ballot</i>',
        htmlAfter: ''
      }]
    }]
},
{
    title: 'Vehículos',
    roles:[],
    items: [{
      title: 'Vehículos',
      htmlBefore: '<i class="material-icons">directions_car</i>',
      htmlAfter: '',
      items:[{
        title:'Vehículos',
        to:'/vehicles'
      },{
        title:'Vencimientos',
        to:'/vehicles/expirations'
      },{
        title:'Marcas',
        to:'/brands'
      },{
        title:'Modelos',
        to:'/models/0'
      },{
        title:'Plan de mantenimiento',
        to:'/maintenance-plans'
      }]
    }]
},
{
  title: 'Vehículos Propios',
  roles:[],
  items:[{
      title: 'Vehículos Propios',
      htmlBefore: '<i class="material-icons">directions_car</i>',
      htmlAfter: '',
      items:[{
        title:'Vehículos',
        to:'/contractVehicles?id=0'
      },{
        title:'Matrices de autorización',
        to:'/authorizationMatrices?idContract=0'
      },{
        title:'Politicas de flota',
        to:'/policies?idContract=0'
      }]
  }]
},
{
  roles:[],
  items:[{
      open: false,
      htmlBefore: '<i class="material-icons">enhanced_encryption</i>',
      htmlAfter: '',
      title:'Seguros',
      items:[{
        title:' Seguro',
        to:'/insurances'
      },{
        title:'Broker',
        to:'/brokers'
      },{
        title:'Productores',
        to:'/producers'
      }
    ]
}]
},
{
  roles:[],
  items:[{
      open: false,
      htmlBefore: '<i class="material-icons">assignment</i>',
      htmlAfter: '',
      title:'Ordenes',
      items:[{
        title:'Ordenes de Trabajo',
        //to:'/errors'
        to:'/work-orders'
      },{
        title:'Turnos',
        //to:'/errors'
        to:'/work-orders/calendar'
      },{
        title:'Nueva',
//        to:'/errors'
        to:'/work-order/0'
      },{
        title:'Mis alertas',
//        to:'/errors'
        to:'/work-orders/alerts'
      }]
}]
},{
  roles:[],
  items:[{
      title:'Facturación',
      open: false,
      htmlBefore: '<i class="material-icons">attach_money</i>',
      htmlAfter: '',
      items:[{
        title:'Comprobantes',
        to:'/vouchers'
      },{
        title:'Pendiente',
        to:'/work-orders-pending-vouchers'
      },{
        title:'Nuevo',
        to:'/vouchers/new'
      },{
        title:'Verificacion CUIT',
        to:'/pending-cuit-verification'
      }]
    }]
},{
    title:'Informes',
    roles:[],
    items:[{
      title:'Informes',
      htmlBefore: '<i class="material-icons">insert_chart</i>',
      htmlAfter: '',
      to:'/errors'
    }]
},{
    title:'Novedades',
    roles:[],
    items:[{
      title:'Novedades',
      htmlBefore: '<i class="material-icons">new_releases</i>',
      htmlAfter: '',
      to:'/errors'
    }]
},
{
    title:'General',
    roles:['web.admin'],
    items:[{
        title:'General',
        htmlBefore: '<i class="material-icons">settings</i>',
        htmlAfter: '',
        items:[{
          title:'Usuarios',
          to:'/users',
          exact: ['super-admin']
        },{
          title:'Roles',
          to:'/roles',
          exact: ['super-admin']
        },{
          title:'Permisos',
          to:'/permissions',
          exact: ['super-admin']
        }]
    }]
},
{
  title:'Mobile Admin',
  roles:['mobile.admin'],
  items:[{
      title:'Mobile Admin',
      htmlBefore: '<i class="material-icons">settings</i>',
      htmlAfter: '',
      items:[{
        title:'Usuarios',
        to:'/mobile/users',
        exact: ['mobile-admin']
      }]
  }]
}
]};
/*
    , {
      title: 'Online Store',
      to: '/ecommerce',
      htmlBefore: '<i class="material-icons">&#xE8D1;</i>',
      htmlAfter: '',
    }, {
      title: 'Personal Blog',
      to: '/blog-overview',
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: '',
    }],
  },
  {
    title: 'Templates',
    items: [{
      title: 'User Account',
      htmlBefore: '<i class="material-icons">&#xE7FD;</i>',
      open: false,
      items: [{
        title: 'User Profile',
        to: '/user-profile',
      }, {
        title: 'User Profile Lite',
        to: '/user-profile-lite',
      }, {
        title: 'Edit User Profile',
        to: '/edit-user-profile',
      }, {
        title: 'Login',
        to: '/login',
      }, {
        title: 'Register',
        to: '/register',
      }, {
        title: 'Change Password',
        to: '/change-password',
      }, {
        title: 'Forgot Password',
        to: '/forgot-password',
      },
      ],
    }, {
      title: 'File Managers',
      htmlBefore: '<i class="material-icons">&#xE2C7;</i>',
      open: false,
      items: [{
        title: 'Files - List View',
        to: '/file-manager-list',
      }, {
        title: 'Files - Cards View',
        to: '/file-manager-cards',
      }],
    }, {
      title: 'Transaction History',
      htmlBefore: '<i class="material-icons">&#xE889;</i>',
      to: '/transaction-history',
    }, {
      title: 'Calendar',
      htmlBefore: '<i class="material-icons">calendar_today</i>',
      to: '/calendar',
    }, {
      title: 'Add New Post',
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: '/add-new-post',
    }, {
      title: 'Errors',
      htmlBefore: '<i class="material-icons">error</i>',
      to: '/errors',
    }],
  }, {
    title: 'Components',
    items: [{
      title: 'Overview',
      htmlBefore: '<i class="material-icons">view_module</i>',
      to: '/components-overview',
    }, {
      title: 'Tables',
      htmlBefore: '<i class="material-icons">table_chart</i>',
      to: '/tables',
    }, {
      title: 'Blog Posts',
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: '/blog-posts',
    }],
  }, {
    title: 'Layouts',
    items: [{
      title: 'Header Nav',
      htmlBefore: '<i class="material-icons">view_day</i>',
      to: '/header-navigation',
    }, {
      title: 'Icon Sidebar',
      htmlBefore: '<i class="material-icons">&#xE251;</i>',
      to: '/icon-sidebar-nav',
    }],
  },
  ];
}
*/